import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchProgramsApi } from '../../../utils/redux/programs/programsAction';
import { Card, Container } from 'react-bootstrap';

const ProgramPage = () => {
    const { programs } = useSelector(state => state.programs);
    const dispatch = useDispatch();

    const fetchPrograms = async () => {
        await dispatch(fetchProgramsApi());
    }

    useEffect(() => {
        fetchPrograms();
    }, []);

    if (!programs)
        return <>Loading</>;

    return (
        <Container className='py-4'>
            <Card className='p-5'>
                {
                    programs && programs?.length && programs.map((program, i) => (
                        <div
                            style={{
                                margin: "10px 0px"
                            }} key={i}>
                            <div
                                style={{
                                    fontWeight: "bold",
                                    display: "inline"
                                }}
                            >
                                {program?.name}
                            </div>
                            :&nbsp;
                            <a target='_blank' href={program?.link}>One Drive Link</a>
                        </div>
                    ))
                }
            </Card>
        </Container>
    )
}

export default ProgramPage